module.exports = __webpack_public_path__ + "static/rajoshi-ada370def1c646022f44cabfcefcdebd.jpeg";